// AddProductEditModal.jsx

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { X } from "react-feather";
import Select, { components } from "react-select";
import { SaleService } from "../../../../services/sale/saleService.ts";
import { MenuTreeService } from "../../../../services/sale/menuTreeService.ts";   // <-- ADDED


function createEmptySelectionState() {
  return {
    holds: {},
    subs: {},
    preps: {},
    extras: {},
    ingredientNotes: {},
  };
}

export default function AddProductEditModal({
  isOpen,
  onClose,
  rowData,
  onSave,
}) {
  const mainTabKey = rowData?.label || "Product";

  const [tabStates, setTabStates] = useState({[mainTabKey]: createEmptySelectionState(), });

  const [activeTab, setActiveTab] = useState(mainTabKey);
  const [dynamicTabs, setDynamicTabs] = useState([]);
// 🔥 Extras state
const [extraCategories, setExtraCategories] = useState([]);
const [internalRow, setInternalRow] = useState(rowData);
  const currentState = tabStates[activeTab] || createEmptySelectionState();

  const updateState = (mutator) => {
    setTabStates((prev) => ({
      ...prev,
      [activeTab]: mutator(prev[activeTab] || createEmptySelectionState()),
    }));
  };
const CustomMultiValue = (props) => {
  const item = props.data.item;

  return (
    <div
      style={{
        background: "#0aa2c0",
        color: "white",
        borderRadius: "6px",
        padding: "4px 8px",
        marginRight: "6px",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",       // spacing between qty and label
      }}
    >
      {/* ⭐ quantity only */}
      {item?.isQuantified && (
        <input
          type="number"
          min={1}
          value={item.quantity ?? 1}
          onFocus={(e) => e.target.select()}
          onClick={(e) => e.target.select()}
          onChange={(e) =>
            item.onQuantityChange(Number(e.target.value) || 1)
          }
          style={{
            width: "28px",
            background: "white",
            borderRadius: "4px",
            border: "1px solid rgba(255,255,255,0.6)",
            fontSize: "0.75rem",
            height: "22px",
            textAlign: "center",
            padding: 0,
            lineHeight: "22px",
            outline: "none",
            color: "#333",
          }}
        />
      )}

      {/* ⭐ NO CUSTOM LABEL — this avoided duplication */}

      {/* ⭐ but we style MultiValueRemove to LOOK like the label */}
      <components.MultiValueRemove
        {...props}
        innerProps={{
          ...props.innerProps,
          style: {
            cursor: "pointer",
            fontWeight: 500,
            color: "white",
          },
        }}
      />
    </div>
  );
};


  const parentPriceOption =
    rowData?.priceOption || rowData?.PriceOptionRaw || null;
  const buildPriceOption = async (productId, isExtraCharge) => {
    if (!parentPriceOption) return null;

    // ✅ FREE SUBSTITUTE – copy parent code/desc, price = 0, mark IsExtraCharge = false
    if (!isExtraCharge) {
      return {
        productId,
        PriceCodeID: parentPriceOption.priceCodeId ?? parentPriceOption.PriceCodeID ?? null,
        PriceCode: parentPriceOption.priceCode ?? parentPriceOption.PriceCode ?? null,
        Description: parentPriceOption.description ?? parentPriceOption.Description ?? "",
        ItemPrice: 0,
        Vat: 0,
        Unit: parentPriceOption.unit ?? parentPriceOption.Unit ?? null,
        IsExtraCharge: false,
      };
    }

    // ✅ EXTRA-CHARGE SUBSTITUTE – load its own price, mark IsExtraCharge = true
    try {
      const list = await MenuTreeService.getProductPrice(Number(productId));
      if (!Array.isArray(list) || list.length === 0) return null;

      let match = list.find(
        (p) => p.PriceCodeID === parentPriceOption.PriceCodeID
      );
      if (!match) match = list[0];

      return {
        productId,
        PriceCodeID: match.PriceCodeID,
        PriceCode: match.PriceCode,
        Description: match.Description,
        ItemPrice: match.ItemPrice,
        Vat: match.Vat,
        Unit: match.Unit,
        IsExtraCharge: true,
      };
    } catch (err) {
      console.error("price load failed", err);
      return null;
    }
  };


  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!rowData) return;

    const mainState = rowData.selectionState
      ? {
        ...createEmptySelectionState(),
        ...rowData.selectionState,
        ingredientNotes: {
          ...(rowData.selectionState.ingredientNotes || {}),
          ...(rowData.ingredientNotes || {}),
        },
      }
      : {
        ...createEmptySelectionState(),
        ingredientNotes: { ...(rowData.ingredientNotes || {}) },
      };

    let restored = {
      [mainTabKey]: mainState,
    };

    const savedSubs = Object.values(mainState.subs || {}).filter(
      (s) => s && s.trim().length > 0
    );

    if (savedSubs.length > 0) {
      Promise.all(
        savedSubs.map(async (subName) => {
          const comboItem = (rowData.combinations || [])
            .flatMap((c) => c.CombinationItems || [])
            .find((i) =>
              i.SubstituitonItems?.some(
                (s) => s.SubstituteProductName === subName
              )
            );

          if (!comboItem) return null;

          const match = comboItem.SubstituitonItems.find(
            (s) => s.SubstituteProductName === subName
          );
          if (!match) return null;

          const substituteId = match.FK_ProductSubstitutionID;
          const isExtra = !!match.IsExtraCharge;

          const combos =
            (await SaleService.getProductCombinations(
              Number(substituteId)
            )) || [];

          const priceOption = await buildPriceOption(substituteId, isExtra);

          const newKey = `sub-${subName.replace(/\s+/g, "-")}`;

          restored[newKey] = {
            ...createEmptySelectionState(),
            priceOption,
          };

          return {
            key: newKey,
            title: subName,
            productId: substituteId,
            combinations: combos,
            priceOption,
            isExtraCharge: isExtra,
          };
        })
      ).then((tabs) => {
        setDynamicTabs(tabs.filter(Boolean));
        setTabStates(restored);
        setActiveTab(mainTabKey);
      });
    } else {
      setDynamicTabs([]);
      setTabStates(restored);
      setActiveTab(mainTabKey);
    }
  }, [rowData]);
  /* eslint-enable react-hooks/exhaustive-deps */

useEffect(() => {
  if (!rowData?.FK_ProductID) return;

  let isMounted = true;

  (async () => {
    const data = await SaleService.listProductExtras(rowData.FK_ProductID);

    if (!isMounted) return;

    const mapped = (data ?? []).map(cat => ({
      id: cat.ProductExtraCategoryID,
      name: cat.Category,
      items: cat.ExtraItems.map(x => ({
        productExtraId: x.ProductExtraID,
        productId: x.ExtraProductID,
        name: x.ExtraProduct,
        isQuantified: x.IsQuantified,
        quantity: x.Quantity ?? 1,
        isExtraCharge: x.IsExtraCharge
      }))
    }));

    setExtraCategories(mapped);
  })();

  return () => {
    isMounted = false;
  };
}, [rowData?.FK_ProductID]);


  if (!isOpen) return null;

  // Build components list (same as original)
  const ingredientComponents = (() => {
    const combos =
      activeTab === mainTabKey
        ? rowData?.combinations || []
        : dynamicTabs.find((t) => t.key === activeTab)?.combinations || [];

    if (!combos.length) return [];

    const map = new Map();

    combos.forEach((combo) => {
      (combo.CombinationItems || []).forEach((item) => {
        const key = item.FK_ProductItemID ?? item.ProductItemName;
        if (map.has(key)) return;

        map.set(key, {
          key,
          name: item.ProductItemName,
          canHold:
            combo.IsOptional === true ? true : false,
          hasSub:
            Array.isArray(item.SubstituitonItems) &&
            item.SubstituitonItems.length > 0,
          substitutes: (item.SubstituitonItems || []).map(
            (s) => s.SubstituteProductName
          ),
          hasPreparation:
            Array.isArray(item.Methods) && item.Methods.length > 0,
          preparations: (item.Methods || []).map((m) => ({
            value: m.Method,
            label: m.Method,
          })),
        });
      });
    });

    return Array.from(map.values());
  })();

  const substituteTabs = Array.from(
    new Set(
      Object.values(currentState.subs || {}).filter(
        (s) => s && String(s).trim().length > 0
      )
    )
  );

  const allTabs = [mainTabKey, ...substituteTabs];

  // ------------------------------
  // SUBSTITUTE CHANGE (WHERE LOGIC IS ADDED)
  // ------------------------------
  const handleSubstituteChange = async (comp, newName) => {
    updateState((prev) => ({
      ...prev,
      subs: {
        ...prev.subs,
        [comp.name]: newName,
      },
    }));

    if (!newName) return;

    const comboItem = (rowData?.combinations || [])
      .flatMap((c) => c.CombinationItems || [])
      .find((i) => i.ProductItemName === comp.name);

    const match = comboItem?.SubstituitonItems?.find(
      (s) => s.SubstituteProductName === newName
    );

    if (!match) return;

    const substituteId = match.FK_ProductSubstitutionID;
    const isExtraCharge = !!match.IsExtraCharge;

    const combos =
      (await SaleService.getProductCombinations(Number(substituteId))) || [];

    const priceOption = await buildPriceOption(substituteId, isExtraCharge);
    const newKey = `sub-${newName.replace(/\s+/g, "-")}`;
    const pointerId = crypto.randomUUID();

    // add substitute tab
    setDynamicTabs((prev) => {
      const exists = prev.find((t) => t.key === newKey);
      if (exists) {
        return prev.map((t) =>
          t.key === newKey
            ? {
              ...t,
              title: newName,
              productId: substituteId,
              combinations: combos,
              priceOption,
              isExtraCharge,
            }
            : t
        );
      }
      return [
        ...prev,
        {
          key: newKey,
          title: newName,
          productId: substituteId,
          combinations: combos,
          priceOption,
          isExtraCharge,
          PointerID: pointerId,        // 🔥 ADDED
          SubstituteName: newName,     // 🔥 ADDED
        },
      ];
    });

    // init state
    setTabStates((prev) => ({
      ...prev,
      [newKey]: {
        ...(prev[newKey] || createEmptySelectionState()),
        priceOption,
      },
    }));
  };

  // ------------------------------
  // SAVE – ADD PRICEOPTION TO RESULTS
  // ------------------------------
  const handleSave = () => {
    const results = [];

    // MAIN
    (() => {
      const state = tabStates[mainTabKey];
      const autoNotes = [];

      ingredientComponents.forEach((comp) => {
        const name = comp.name;
        if (state.holds[name]) autoNotes.push(`Hold ${name}`);
        if (state.subs[name]) autoNotes.push(`${name} → ${state.subs[name]}`);
        if (state.preps[name]) autoNotes.push(`${name}: ${state.preps[name]}`);
      });

      Object.entries(state.extras || {}).forEach(([cat, values]) => {
        values.forEach((v) => {
          if (!v) return;

          const isObj = typeof v === "object";
          const name = isObj ? v.label || v.name || "" : String(v);
          const qty = isObj ? v.quantity ?? 1 : 1;

          autoNotes.push(
            qty > 1
              ? `Extra (${cat}): ${name} x${qty}`
              : `Extra (${cat}): ${name}`
          );
        });
      });


      results.push({
        label: mainTabKey,
        autoNotes,
        ingredientNotes: state.ingredientNotes || {},
        selectionState: state,
        combinations: rowData?.combinations || [],
        productId: rowData?.FK_ProductID,
        priceOption: parentPriceOption || null,
      });
    })();

    // SUBSTITUTES
    dynamicTabs.forEach((tab) => {
      const state = tabStates[tab.key] || createEmptySelectionState();
      const autoNotes = [];

      const combos = tab.combinations || [];
      combos.flatMap((c) => c.CombinationItems || []).forEach((comp) => {
        const name = comp.ProductItemName;
        if (state.holds[name]) autoNotes.push(`Hold ${name}`);
        if (state.subs[name]) autoNotes.push(`${name} → ${state.subs[name]}`);
        if (state.preps[name]) autoNotes.push(`${name}: ${state.preps[name]}`);
      });

      Object.entries(state.extras || {}).forEach(([cat, values]) => {
        values.forEach((v) => autoNotes.push(`Extra (${cat}): ${v}`));
      });

      results.push({
        label: tab.title,
        autoNotes,
        ingredientNotes: state.ingredientNotes || {},
        selectionState: state,
        combinations: tab.combinations,
        productId: tab.productId,
        priceOption: tab.priceOption || null,

        // 🔥 NEW FIELDS
        PointerID: tab.PointerID ?? null,
        SubstituteName: tab.title,
        _isChild: true,
      });
    });

    onSave(results);
  };

  // ------------------------------
  // UI (UNCHANGED)
  // ------------------------------
  return (
    <div
      className="modal fade show d-block pos-modal"
      style={{ background: "rgba(0,0,0,0.45)", zIndex: 30000 }}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content rounded-4 shadow-lg">
          {/* HEADER */}
          <div className="modal-header border-0 pb-2">
            <h5 className="modal-title fw-semibold">
              Edit Options – {rowData?.label}
            </h5>
            <button
              className="btn btn-light"
              onClick={onClose}
              style={{ borderRadius: "50%" }}
            >
              <X size={18} />
            </button>
          </div>

          {/* TABS */}
          <ul className="nav nav-tabs px-3 pos-modal-tabs">
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link ${activeTab === mainTabKey ? "active" : ""
                  }`}
                onClick={() => setActiveTab(mainTabKey)}
              >
                {mainTabKey}
              </button>
            </li>

            {dynamicTabs.map((tab) => (
              <li className="nav-item" key={tab.key}>
                <button
                  type="button"
                  className={`nav-link ${activeTab === tab.key ? "active" : ""
                    }`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.title}
                </button>
              </li>
            ))}
          </ul>

          {/* BODY */}
          <div className="modal-body">
            <h5 className="fw-semibold mb-3">Ingredients</h5>

            {/* ingredient table (UNCHANGED) */}
            <table className="table table-bordered table-sm align-middle">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "20%" }}>Ingredient</th>
                  <th style={{ width: "8%", textAlign: "center" }}>Hold</th>
                  <th style={{ width: "28%" }}>Substitute</th>
                  <th style={{ width: "24%" }}>Preparation</th>
                  <th style={{ width: "20%" }}>Note</th>
                </tr>
              </thead>

              <tbody>
                {ingredientComponents.map((comp) => (
                  <tr key={comp.key || comp.name}>
                    <td className="fw-semibold">{comp.name}</td>

                    <td className="text-center">
                      {comp.canHold && (
                        <input
                          type="checkbox"
                          checked={!!currentState.holds[comp.name]}
                          onChange={(e) =>
                            updateState((prev) => ({
                              ...prev,
                              holds: {
                                ...prev.holds,
                                [comp.name]: e.target.checked,
                              },
                            }))
                          }
                        />
                      )}
                    </td>

                    <td>
                      {comp.hasSub ? (
                        <Select
                          options={comp.substitutes.map((s) => ({
                            value: s,
                            label: s,
                          }))}
                          placeholder="Select substitute"
                          value={
                            currentState.subs[comp.name]
                              ? {
                                value: currentState.subs[comp.name],
                                label: currentState.subs[comp.name],
                              }
                              : null
                          }
                          onChange={async (opt) => {
                            const newName = opt?.value ?? "";
                            await handleSubstituteChange(comp, newName);
                          }}
                        />
                      ) : (
                        <span className="text-muted small">N/A</span>
                      )}
                    </td>

                    <td>
                      {comp.hasPreparation ? (
                        <Select
                          options={comp.preparations || []}
                          placeholder="Select preparation"
                          value={
                            currentState.preps[comp.name]
                              ? {
                                value: currentState.preps[comp.name],
                                label: currentState.preps[comp.name],
                              }
                              : null
                          }
                          onChange={(opt) =>
                            updateState((prev) => ({
                              ...prev,
                              preps: {
                                ...prev.preps,
                                [comp.name]: opt?.value ?? "",
                              },
                            }))
                          }
                        />
                      ) : (
                        <span className="text-muted small">N/A</span>
                      )}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder={`Note for ${comp.name}`}
                        value={currentState.ingredientNotes[comp.name] || ""}
                        onChange={(e) =>
                          updateState((prev) => ({
                            ...prev,
                            ingredientNotes: {
                              ...prev.ingredientNotes,
                              [comp.name]: e.target.value,
                            },
                          }))
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>

                       {/* Extras */}
            <h5 className="fw-semibold mt-4 mb-2">Extras</h5>
{/* Extras - upgraded with quantity support */}
<h5 className="fw-semibold mt-4 mb-2">Extras</h5>
<div className="row">
  {extraCategories.map((cat) => {
    const selected = currentState.extras?.[cat.name] ?? [];

    // create mapping for react-select
    const options = cat.items.map((item) => ({
      value: item.productExtraId,
      label: item.name,
      item, // attach metadata for later
    }));

    const selectedValues = selected.map((s) => {
      const match = cat.items.find((x) => x.productExtraId === s.productExtraId);
      return {
        value: s.productExtraId,
        label: match?.name ?? "",
        item: {
          ...match,
          quantity: s.quantity ?? 1,
          onQuantityChange: (qty) => {
            const updated = [...selected];
            const idx = updated.findIndex(
              (x) => x.productExtraId === s.productExtraId
            );
            if (idx !== -1) {
              updated[idx] = { ...updated[idx], quantity: qty };
              updateState((prev) => ({
                ...prev,
                extras: { ...prev.extras, [cat.name]: updated },
              }));
            }
          },
        },
      };
    });
    return (
      <div className="col-md-4 mb-3" key={cat.name}>
        <label className="small text-muted d-block mb-1">{cat.name}</label>

        <Select
          classNamePrefix="pos"
          isMulti
          closeMenuOnSelect={false}
           components={{
  MultiValue: CustomMultiValue,
}}
          options={options.map((opt) => ({
            ...opt,
            item: {
              ...opt.item,
               onQuantityChange: (_qty) => undefined,
            },
          }))}
          placeholder={`Select ${cat.name.toLowerCase()}`}
          value={selectedValues}
          onChange={(opts) => {
            const mapped = (opts || []).map((o) => ({
              productExtraId: o.value,
              productId: o.item.productId,
              name: o.item.name,
              isQuantified: o.item.isQuantified,
              quantity: o.item.isQuantified ? (o.item.quantity ?? 1) : 1,
            }));

            updateState((prev) => ({
              ...prev,
              extras: { ...prev.extras, [cat.name]: mapped },
            }));
          }}
        />
      </div>
    );
  })}
</div>


          </div>

          {/* FOOTER */}
          <div className="modal-footer border-0 pt-0">
            <button className="btn btn-primary px-4" onClick={handleSave}>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

AddProductEditModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rowData: PropTypes.shape({
    label: PropTypes.string,
    currentState: PropTypes.object,
    ingredientNotes: PropTypes.object,
    combinations: PropTypes.array,
  }),
  onSave: PropTypes.func.isRequired,
};

AddProductEditModal.defaultProps = {
  rowData: null,
};
